import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import FormFieldMultiSelect, { MultiSelectProps } from '@/components/FormFieldMultiSelect';
import FormFieldComponent from '@/components/FormFieldComponent';
import FormFieldCheckbox from '@/components/FormFieldCheckbox';
import { CLIENT_CONTACT_STEP } from '@/utils/constant';
import { ContactDetails } from '@/components/ContactForm';
import { buildDataExchangeEmailOptions } from './dataExchangeEmailOptions';

const ClientDataExchange = ({ mode, goToStep }: { mode: 'edit' | 'create'; goToStep: (step: number) => void }) => {
  const { control, getValues } = useFormContext();
  const addNewEmailOption = {
    label: 'Add New Email Address',
    onClick: () => goToStep(CLIENT_CONTACT_STEP),
  };
  const emailOptions = useMemo(
    () => buildDataExchangeEmailOptions((getValues('contacts') as ContactDetails[]) ?? []),
    [getValues('contacts')]
  );

  useWatch({
    control,
    name: 'canAffidavitWithInvoice',
  });

  useWatch({
    control,
    name: 'affidavit',
  });

  const multiSelectFieldProps = {
    label: 'Email Address',
    placeholder: 'Select Email Addresses',
    options: emailOptions,
    addNewOption: addNewEmailOption,
    mode: mode,
    labelToDisplay: {
      dropdown: 'label1' as MultiSelectProps['labelToDisplay']['dropdown'],
      selectedOption: 'label2' as MultiSelectProps['labelToDisplay']['selectedOption'],
    },
  };

  return (
    <div className="flex flex-col gap-8 mt-10 w-full ">
      <div className="w-full flex flex-col md:flex-row md:gap-6  gap-0 ">
        <div className="w-[250px] font-[500]">
          <span className="text-base">Affidavits</span>
        </div>
        <div className="grid grid-rows-1 md:grid-cols-2 w-full gap-6">
          <FormFieldMultiSelect name="affidavit" {...multiSelectFieldProps} />
          <FormFieldComponent
            name="affidavitCc"
            label="CC Email Address"
            control={control}
            placeholder="Enter Email Addresses"
          />
        </div>
      </div>
      <div className="w-full flex flex-col md:flex-row md:gap-6  gap-0 ">
        <div className="w-[250px] font-[500]">
          <span className="text-base">A/R Invoices </span>
        </div>
        <div className="grid grid-rows-1 md:grid-cols-2 w-full gap-6">
          <FormFieldMultiSelect name="arInvoices" {...multiSelectFieldProps} />
          <FormFieldComponent
            name="arInvoicesCc"
            label="CC Email Address"
            control={control}
            placeholder="Enter Email Addresses"
          />
        </div>
      </div>
      <div className="w-full flex flex-col md:flex-row md:gap-6  gap-0 ">
        <div className="w-[250px] font-[500]">
          <span className="text-base">Final Billing Summary</span>
        </div>
        <div className="grid grid-rows-1 md:grid-cols-2 w-full gap-6">
          <FormFieldMultiSelect name="finalBillingSummary" {...multiSelectFieldProps} />
          <FormFieldComponent
            name="finalBillingSummaryCc"
            label="CC Email Address"
            control={control}
            placeholder="Enter Email Addresses"
          />
        </div>
      </div>
      <div className="w-full flex flex-col md:flex-row md:gap-6  gap-0 ">
        <div className="w-[250px] font-[500]">
          <span className="text-base">Recap & Invoice</span>
        </div>
        <div className="grid grid-rows-1 md:grid-cols-2 w-full gap-6">
          <FormFieldMultiSelect name="recapAndInvoice" {...multiSelectFieldProps} />
          <FormFieldComponent
            name="recapAndInvoiceCc"
            label="CC Email Address"
            control={control}
            placeholder="Enter Email Addresses"
          />
        </div>
      </div>
      <div className="w-full flex flex-col md:flex-row md:gap-6  gap-0 ">
        <div className="w-[250px] font-[500]">
          <span className="text-base">Statements</span>
        </div>
        <div className="grid grid-rows-1 md:grid-cols-2 w-full gap-6">
          <FormFieldMultiSelect name="statement" {...multiSelectFieldProps} />
          <FormFieldComponent
            name="statementCc"
            label="CC Email Address"
            control={control}
            placeholder="Enter Email Addresses"
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 text-base font-[500]">
        <FormFieldCheckbox
          className="p-0"
          labelClassName="text-base font-medium"
          control={control}
          name="canAffidavitWithInvoice"
          label="Affidavit with Invoice"
        />
        <div className="p-2">
          {getValues('canAffidavitWithInvoice') == true && (
            <div className="grid grid-rows-1 md:grid-cols-2 w-[60vw] gap-6">
              <FormFieldMultiSelect name="affidavitWithInvoice" {...multiSelectFieldProps} />
              <FormFieldComponent
                name="affidavitWithInvoiceCc"
                label="CC Email Address"
                control={control}
                placeholder="Enter Email Addresses"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientDataExchange;
